'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var Box = function (_React$Component) {
    (0, _inherits3.default)(Box, _React$Component);

    function Box() {
        (0, _classCallCheck3.default)(this, Box);
        return (0, _possibleConstructorReturn3.default)(this, (Box.__proto__ || (0, _getPrototypeOf2.default)(Box)).apply(this, arguments));
    }

    (0, _createClass3.default)(Box, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                level = _props.level,
                solid = _props.solid,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'level', 'solid']);


            className = (0, _classnames2.default)('box', (0, _Utils.getComponentLevelClassName)('box', level), {
                'box-solid': solid
            }, className);

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: className }, otherProps),
                children
            );
        }
    }]);
    return Box;
}(_react2.default.Component);

Box.PropTypes = {
    className: _react2.default.PropTypes.string,
    children: _Utils.COMPONENT_CHILDREN,
    level: _react2.default.PropTypes.oneOf(_Utils.COMPONENT_LEVELS),
    solid: _react2.default.PropTypes.bool
};
exports.default = Box;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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